import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("ll_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const TIER_LABEL = { top_spot: "Elite", featured: "Pro", basic: "Basic" };
export const TIER_RANK = { top_spot: 0, featured: 1, basic: 2 };
// Lead capture: Pro + Elite tiers receive contact submissions. Basic is phone-only.
export const TIER_HAS_LEADS = { top_spot: true, featured: true, basic: false };
// Photo limits per tier (enforced backend; UI gates upload count).
export const TIER_PHOTO_LIMIT = { top_spot: 20, featured: 5, basic: 1 };
